import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getRplRNA = 'sertifikasi-rpl';
const postRplRnaUrl = 'sertifikasi-rpl';
const getDetailRplRNA = 'sertifikasi-rpl/';
const deleteRplRNA = 'sertifikasi-rpl/delete-sertifikasi-rpl/';
const putRplRnaUrl = 'sertifikasi-rpl/';

class RplRNAService {
    getRplRNA(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getRplRNA + '?pageNo=' + currentPage + '&pageSize=' +  pageSize  + '&filter=' + filter + '&kategoriRpl=RNA',
            {
                headers: authHeader()
            });
    }
    getDetailRplRNA(idSertifikasiRpl) {
        return axios.get(
            API_URL + getDetailRplRNA + idSertifikasiRpl,
            {
                headers: authHeader()
            });
    }

    postRplRna(formData) {
        return axios.post(
            API_URL + postRplRnaUrl,
            formData,
            {
                headers: authHeader()
            }
        );
    }


    putRplRNA(formData) {
        return axios.put(
            API_URL + putRplRnaUrl + formData.idSertifikasiRpl,
            formData,
            {
                headers: authHeader()
            }
        );
  
    }

    deleteRplRNA(formData) {
        return axios
        .delete(
            API_URL + deleteRplRNA + formData, {
                headers: authHeader()
            }
        );
    }

}

export default new RplRNAService();
